var _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoiSelected = function SvgPoiSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 41"
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 34,
    viewBox: "0 0 24 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061AB1",
    d: "M11.904 33.175c5.208-2.885 11.904-11.932 11.904-20.46 0-6.953-5.33-12.59-11.904-12.59S0 5.762 0 12.715c0 7.87 6.944 17.575 11.904 20.46m0-12.59c4.383 0 7.936-3.759 7.936-8.394 0-4.636-3.553-8.394-7.936-8.394s-7.936 3.758-7.936 8.394c0 4.635 3.553 8.393 7.936 8.393"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.904,
    cy: 12.191,
    fill: "#FF860D",
    rx: 7.936,
    ry: 8.394
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.904,
    cy: 12.191,
    fill: "#061AB1",
    rx: 3.84,
    ry: 4.061
  }))));
};
export default SvgPoiSelected;